/**
 * Countdown Timer Section
 * Vanilla JS — no dependencies.
 * Supports multiple instances on the same page and re-initializes
 * automatically inside the Shopify theme editor.
 */
(function () {
  'use strict';

  var INTERVAL_MS = 1000;
  var timers = {}; // sectionId -> interval id, so re-init doesn't stack intervals

  function parseEndDate(raw) {
    if (!raw) return null;

    var value = raw.trim();

    // Accept "YYYY-MM-DD HH:MM" (space) or "YYYY-MM-DDTHH:MM" (already ISO-like).
    if (value.indexOf('T') === -1 && value.indexOf(' ') !== -1) {
      value = value.replace(' ', 'T');
    }

    // Add seconds if only HH:MM was provided.
    var hasSeconds = /T\d{2}:\d{2}:\d{2}/.test(value);
    if (!hasSeconds && /T\d{2}:\d{2}$/.test(value)) {
      value += ':00';
    }

    var date = new Date(value);

    if (isNaN(date.getTime())) {
      // Fall back to letting the browser parse the raw string as-is.
      date = new Date(raw);
    }

    return isNaN(date.getTime()) ? null : date;
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function updateDisplay(root, remainingMs) {
    var totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));

    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);

    return totalSeconds;
  }

  function stopTimer(sectionId) {
    if (timers[sectionId]) {
      clearInterval(timers[sectionId]);
      delete timers[sectionId];
    }
  }

  function setEndedState(root, ended) {
    var activeEl = root.querySelector('[data-countdown-active]');
    var endedEl = root.querySelector('[data-countdown-ended-message]');

    if (activeEl) activeEl.hidden = ended;
    if (endedEl) endedEl.hidden = !ended;

    if (ended) {
      root.setAttribute('data-countdown-ended', 'true');
    } else {
      root.removeAttribute('data-countdown-ended');
    }
  }

  function initCountdown(root) {
    if (!root || !(root instanceof HTMLElement)) return;

    var sectionId = root.id;
    var endDate = parseEndDate(root.getAttribute('data-end-date'));

    // Always clear any existing interval for this instance before starting a new one
    // (important for theme editor "input" events firing repeatedly).
    stopTimer(sectionId);

    if (!endDate) {
      // No valid end date configured — treat as not-yet-ended, show zeros.
      setEndedState(root, false);
      updateDisplay(root, 0);
      return;
    }

    function tick() {
      var remaining = endDate.getTime() - Date.now();

      if (remaining <= 0) {
        updateDisplay(root, 0);
        setEndedState(root, true);
        stopTimer(sectionId);
        return;
      }

      setEndedState(root, false);
      updateDisplay(root, remaining);
    }

    tick();

    // Only keep ticking if the countdown hasn't already ended.
    if (endDate.getTime() - Date.now() > 0) {
      timers[sectionId] = setInterval(tick, INTERVAL_MS);
    }
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll('[data-countdown-timer]');
    roots.forEach(function (root) {
      initCountdown(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Shopify theme editor support: re-init on section load/select,
  // and stop the interval when the section is removed or deselected.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-countdown-timer]');
    if (root) initCountdown(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-countdown-timer]');
    if (root) stopTimer(root.id);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-countdown-timer]');
    if (root) initCountdown(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-countdown-timer]');
    if (root) initCountdown(root);
  });
})();
